// Canonical Drive roots for the consolidated filing structure
// (superseding the old scattered AHFC Patient Records / Staff Records paths).
// New uploads should always target these, keyed by the client's G-number or
// staff's E-number -- never a name, never a UUID.
export const CLIENT_DRIVE_ROOT = '1D3t6uDP7w74x7DJLBSaVoFrQB8RRtKI5'; // "6 - Client Folder"
export const STAFF_DRIVE_ROOT = '19Yf6DgjQgeHBZ1NVt6stqbyUN2YXlN8W';  // "5 - Staff Folder"

export const driveFolderUrl = (folderId) =>
  folderId ? `https://drive.google.com/drive/folders/${folderId}` : null;

// Standard subfolders a client/staff document can be filed under.
export const CLIENT_DOC_BUCKETS = [
  'Assessments', 'Supervisor Visits', 'Signing Packets',
  'Authorizations', 'Medical Records', 'Eligibility & Insurance',
  'DME', 'Correspondence', 'Faxes', 'Needs Review',
];
export const STAFF_DOC_BUCKETS = [
  'Onboarding', 'Training & Compliance', 'Agreements', 'Payroll',
  'Personnel', 'Needs Review',
];

// Reads a browser File as base64 (no data: prefix), for edge-function upload.
export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(',')[1] || '');
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
